import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideModal,
  createObra,
  updateObra,
  deleteObra,
} from "../../store/actions/obras";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { ErrorMessage } from "../../components/ErrorMessage";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import InputField from "../../components/InputField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useStyles } from "../../lib/styles/nuevoStyles";

import { obrasForm, defaultVal, validation } from "../../lib/forms/obrasForm";

export const NuevaObra = () => {
  const showModal = useSelector((state) => state.obras.showModal);
  const page = useSelector((state) => state.obras.page);
  const pageSize = useSelector((state) => state.obras.pageSize);
  const dataBuscar = useSelector((state) => state.obras.dataBuscar);
  const obra = useSelector((state) => state.obras.obra);
  const editMode = useSelector((state) => state.obras.editMode);
  const isLoading = useSelector((state) => state.obras.isLoading);
  const error = useSelector((state) => state.obras.error);
  const dispatch = useDispatch();

  const obraAjusted = {
    ...obra,
    taller: obra.taller ? "si" : "no",
  };

  const classes = useStyles();

  const formModel = obrasForm();
  const defaultValues = defaultVal();
  const validationSchema = validation();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: editMode ? obraAjusted : defaultValues,
  });

  const onDelete = () => {
    const id = obra.id;
    if (
      window.confirm(`Esta seguro que desea borrar la obra ${obra.nombre}?`)
    ) {
      dispatch(deleteObra({ id, page, pageSize, dataBuscar }));
    }
  };

  const onSubmit = (values) => {
    const data = {
      ...values,
      taller: values.taller === "si",
    };
    const id = obra.id;
    if (editMode) {
      dispatch(updateObra({ id, data, page, pageSize, dataBuscar }));
    } else {
      dispatch(createObra({ data, pageSize }));
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          dispatch(hideModal());
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          {editMode ? "Editar Obra" : "Agregar Nueva Obra"}
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <Grid container spacing={2}>
              {formModel.map((input) => (
                <Grid item key={input.props.name} md={input.width} xs={12}>
                  <InputField
                    {...input.props}
                    control={control}
                    errors={errors}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
          {error && <ErrorMessage module="obras" />}
        </DialogContent>
        <DialogActions>
          {editMode && (
            <Button onClick={onDelete} className={classes.warning}>
              Borrar Obra
            </Button>
          )}
          <Button
            onClick={() => dispatch(hideModal())}
            color="primary"
            tabIndex={-1}
          >
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {editMode ? "Editar" : "Capturar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
